

define(['jquery', 'angular', 'text!./template.html'], function ($, angular, template) {
    return angular.module('xo-3ds.directive', ['squid']).directive('xo3ds', function () {
        return {
            template: template,
            scope: {
                token: '=',
                data: '=',
                onComplete3dsHandler: '='
            },
            controller: function controller($scope, $rootScope, $timeout, $window, $Resolve3DS, $CheckoutAppDataModel, $config, $locale, $logger) {

                var resolve3DS = $Resolve3DS.instance($scope.token);

                $scope.termUrl = window.location.origin + $config.urls.baseUrl + '/process3DS';

                $scope.data = $scope.data || {};

                function handleInitFailure(message) {
                    // Since init3DS call failed. We disable the feature and proceed to checkout.
                    $CheckoutAppDataModel.instance($rootScope.token).action('updatePaymentExperience', {
                        data: {
                            payment_experience: 'HERMESNODE',
                            '3d_secure_authentication_supported': false
                        },
                        silent: true,
                        transientError: true
                    }).then(function () {

                        $logger.info('checkout_fpti', {
                            from: '3DS_CHALLENGE',
                            to: 'process_3ds_challenge',
                            'int_error_description': message,
                            'error_type': 'soft_decline',
                            'error_source': 'fiLifecycle'
                        });

                        $scope.onComplete3dsHandler('success');
                    });
                }

                function init3DSApi() {
                    $rootScope.$emit('loadingMessage', $locale.content.get('threeDS.processing'));

                    return resolve3DS.action('init3DS', {
                        data: {
                            cc_id: $scope.data.cc_id,
                            flow_id: $scope.data.flow_id,
                            merchant_id: $scope.data.merchant_id,
                            merchant_country: $scope.data.merchant_country_code,
                            currency: $scope.data.transaction_amount_currency,
                            transaction_amount: $scope.data.transaction_amount_value
                        },
                        success: function success(response) {
                            if (response.status === 'SUCCESS' && response.acsUrl) {

                                $logger.info('checkout_fpti', { from: '3DS_CHALLENGE', to: 'prepare_3ds_challenge' });

                                $scope.acsUrl = response.acsUrl;
                                $scope.acsMethod = response.acsMethod || 'POST';
                                $scope.acsPaReq = response.acsPaReq;

                                var lightbox;
                                var form = $('<form/>', {
                                    action: $scope.acsUrl,
                                    method: $scope.acsMethod,
                                    id: 'iFrameForm',
                                    target: 'threeDSFrame'
                                });
                                form.append($('<input/>', {
                                    type: 'hidden',
                                    name: 'TermUrl',
                                    value: $scope.termUrl
                                }));

                                form.append($('<input/>', {
                                    type: 'hidden',
                                    name: 'PaReq',
                                    value: $scope.acsPaReq
                                }));
                                $('#lightBoxAcsWrapper').append(form);
                                $('#iFrameForm').submit();

                                // put lightbox to display with transition
                                lightbox = angular.element(document.getElementById('light-box'));
                                lightbox.addClass('open');
                            } else {
                                $logger.info('checkout_fpti', {
                                    from: '3DS_CHALLENGE',
                                    to: 'process_3ds_challenge',
                                    'int_error_description': 'acsUrl_not_presented_on_init',
                                    'error_type': 'soft_decline',
                                    'error_source': 'fiLifecycle'
                                });

                                // When there is no 3DS challenge page to be shown, we return success to the caller
                                $scope.onComplete3dsHandler('success');
                            }
                        },
                        error: function error() {
                            handleInitFailure('unknown_error_on_init3DS');
                        },
                        validation: function validation() {
                            handleInitFailure('validation_error_on_init3DS');
                        },
                        contingencies: {
                            DEFAULT: function DEFAULT() {
                                handleInitFailure('contingency_presented_on_init3DS');
                            }
                        }
                    });
                }

                function complete3DSApi(paRes) {
                    return resolve3DS.action('complete3DS', {
                        data: {
                            third_party_response: paRes,
                            cc_id: $scope.data.cc_id,
                            flow_id: $scope.data.flow_id
                        },
                        success: function success(response) {

                            var status;

                            if (response.status === 'SUCCESS') {
                                status = 'success';

                                $logger.info('checkout_fpti', {
                                    from: '3DS_CHALLENGE',
                                    to: 'process_3ds_challenge'
                                });
                            } else {
                                status = 'decline';

                                $logger.info('checkout_fpti', {
                                    from: '3DS_CHALLENGE',
                                    to: 'process_3ds_challenge',
                                    'int_error_description': 'complete3DS_decline',
                                    'error_type': 'soft_decline',
                                    'error_source': 'fiLifecycle'

                                });
                            }

                            $scope.onComplete3dsHandler(status);
                        }
                    });
                }

                $scope.close3DSFrame = function () {
                    $logger.info('checkout_fpti', { from: '3DS_CHALLENGE', to: 'process_user_close' });

                    var lightbox = angular.element(document.getElementById('light-box'));
                    lightbox.removeClass('open');

                    $timeout(function () {
                        var lightboxMask = angular.element(document.getElementById('mask'));
                        lightboxMask.remove();
                        $scope.onComplete3dsHandler('close');
                    }, 200);
                };

                init3DSApi();

                $scope.complete3DS = function (paRes) {
                    complete3DSApi(paRes);
                };

                $window.complete3DSFrame = function (paRes) {
                    $scope.complete3DS(paRes);
                };

                // when the esc key is pressed
                $('html').on('keyup', function (ev) {
                    if (ev.which === 27) {
                        $scope.close3DSFrame();
                    }
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/3ds/directive.js
// module id = ./components/xo-wallet-components/src/3ds/directive.js
// module chunks = 1